import { escapeHtml } from './html';

export const convertWhatsAppTextToHtml = (value: string): string => {
  const escaped = escapeHtml(value);
  const withBold = escaped.replace(/\*(.+?)\*/g, '<strong>$1</strong>');
  return withBold.replace(/\n/g, '<br />');
};
